import React from 'react'
function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

const DayViewEventChip = ({event, setEditEvent, setEventToEdit}) => {
  const [mouseOver, setMouseOver] = React.useState(false)

    const openEvent = (e) => {
        setEditEvent(true)
        setEventToEdit(e)
      }

    return (
      <li className={classNames(event.isPendingOffer && "animate-pulse", `relative flex col-start-${event.column} cursor-pointer`, mouseOver ? `z-50` : `z-${event.rowNumber}`)} onMouseEnter={() => setMouseOver(true)} onMouseLeave={() => setMouseOver(false)} onClick={() => openEvent(event)} key={event.id} style={{ gridRow: `${event.rowNumber}/ ${event.rowNumber + event.rowLength}`}}>
          <div className={classNames(
              event.isPendingOffer && `border-solid opacity-70 border-2 ${event.color.borderColor200} bg-gray-200 text-white`, 
              !event.isPendingOffer && `${event.isIntro ? 'bg-amber-100' : `${event.color.textColor200}`}` ,`group absolute inset-x-1 inset-y-0 inset flex flex-col overflow-y-auto rounded-lg px-2 pt-1 text-xs hover:shadow-xl border-2 border-solid ${event.color.borderColor500} transition-shadow duration-300 leading-5 hover:${event.color.bgColor500}`)}
          >
            {event.isPendingOffer && <p className='m-0 text-red-600 text-xs border-2 border-red-600 border-solid text-center rounded-md'>PENDING OFFER</p>}
            <p className={`font-bold text-base m-0 ${event.isIntro ? 'text-amber-500' : `${event.color.textColor500}`}`}>{event.name}</p>
            <p className={`${event.isIntro ? 'text-amber-400' : `${event.color.textColor500}`} m-0 inline w-12 group-hover:${event.isIntro ? 'text-amber-400' : `${event.color.textColor500}`}`}>
              <time dateTime={event.time}>{event.time}</time>
            </p>
            <p className={`m-0 inline w-12 ml-14 -mt-5 ${event.isIntro ? 'text-amber-400' : `${event.color.textColor500}`}`}>{event.lessonLength} min</p>
          </div>
      </li> 
    )
}
export default DayViewEventChip